import { SelectItem } from '@wui/common-library'
import { computed, ref } from 'vue'

import { CallBack } from '@/shared/types/api'

export enum Services {
  DIAL_PAD = 'dialpad',
  WEB_CALL_BACKORDER = 'webCallBackorder',
  SEND_FAX = 'sendFax'
}
export const callBackList = ref<CallBack[]>([])
export const isActiveCallBack = computed(() => {
  return callBackList.value.find((item) => item.status === 0)
})
export const inputTimeoutItems: SelectItem[] = [{
  label: '10',
  value: '10',
}, {
  label: '20',
  value: '20',
},
{
  label: '30',
  value: '30',
},
{
  label: '40',
  value: '40',
},
{
  label: '50',
  value: '50',
},
{
  label: '60',
  value: '60',
}]

export const attemptCountItems: SelectItem[] = [{
  label: '1',
  value: '1',
}, {
  label: '3',
  value: '3',
},
{
  label: '5',
  value: '5',
},
{
  label: '7',
  value: '7',
},
{
  label: '9',
  value: '9',
}]

export const attemptIntervalItems: SelectItem[] = [{
  label: '1',
  value: '1',
},
{
  label: '2',
  value: '2',
}, {
  label: '3',
  value: '3',
},
{
  label: '5',
  value: '5',
}]

export const attemptInputCountItems: SelectItem[] = [{
  label: '1',
  value: '1',
}, {
  label: '3',
  value: '3',
},
{
  label: '5',
  value: '5',
},
{
  label: '7',
  value: '7',
},
{
  label: '9',
  value: '9',
}]
